export default __webpack_public_path__ + "static/media/satvik.96d26c20.png";